import * as core from '../../../../../../../core'

import { query } from './outcome-explore-general.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcome-explore-general',
    description:
      'Displays general information about the currently focused outcome, if there is one',
    name: 'Summit - Outcome Explore General',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
